function PaginationControls({
  currentPage,
  onPageChange,
  pageSize,
  totalItems,
  totalPages,
}) {
  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages;
  const firstItem = totalItems ? (currentPage - 1) * pageSize + 1 : 0;
  const lastItem = totalItems ? Math.min(currentPage * pageSize, totalItems) : 0;

  return (
    <div className="mt-3 rounded-[18px] border border-[#e8ded5] bg-white px-4 py-2.5">
      <nav
        aria-label="Pagination"
        className="flex flex-col gap-2.5 sm:flex-row sm:items-center sm:justify-between"
      >
        <p className="text-sm text-[#6f5644]">
          Showing {firstItem}-{lastItem} of {totalItems}
        </p>

        <div className="flex items-center gap-3">
          <button
            className="inline-flex h-9 min-w-[68px] items-center justify-center rounded-[12px] border border-[#eadfd5] bg-white px-3 text-sm font-semibold text-[#6f5644] transition hover:border-[#d8c8b8] hover:bg-[#fcfbf9] disabled:cursor-not-allowed disabled:text-[#c4b8ad]"
            disabled={!canGoPrevious}
            onClick={() => onPageChange(currentPage - 1)}
            type="button"
          >
            Prev
          </button>

          <span className="text-sm font-medium text-[#111111]">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="inline-flex h-9 min-w-[68px] items-center justify-center rounded-[12px] border border-[#eadfd5] bg-white px-3 text-sm font-semibold text-[#6f5644] transition hover:border-[#d8c8b8] hover:bg-[#fcfbf9] disabled:cursor-not-allowed disabled:text-[#c4b8ad]"
            disabled={!canGoNext}
            onClick={() => onPageChange(currentPage + 1)}
            type="button"
          >
            Next
          </button>
        </div>
      </nav>
    </div>
  );
}

export default PaginationControls;
